module.exports = __webpack_public_path__ + "img/button-light-01.ee8e3037.png";